export default obj => {
  let str = '';
  Object.keys(obj).forEach((item, index, arr) => {
    str += (index !== 0 ? '&' : '') + item + '=' + obj[item];
  });

  return str;
};



// WEBPACK FOOTER //
// ./utils/parseParams.js